import React, { Component } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, Pagination } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import CommonGrid from "../common/commongrid";
import PropertyReportDeed from "./PropertyReportDeed";
import appConfig from '../../config/config';
import { connect } from "react-redux";
 import { LoadAllDeeds,SetDeed,ShowAddDeed } from "../../actions/loading";
import {MTSGetData} from '../../API/mtsapi';
import PageSpinner from  '../../components/PageSpinner'
import PropReportDeedGrid from "./PropertyReportDeedGrid.js";
import { CallAPI } from "../common/formsubmit";
const colHeader = [
    { dataField: 'id', text: 'Sr No' },
    { dataField: 'Grantee', text: 'Grantee' },
    { dataField: 'Grantor', text: 'Grantor' },
    { dataField: 'isPrior', text: 'Prior' },
    { dataField: 'DeedDate', text: 'Deed Date' },
    { dataField: 'RecordedDate', text: 'Rec Date' },
    { dataField: 'ConsiderationAmount', text: 'Consideration' },
    { dataField: 'VolInst', text: 'Vol-Inst' },
    { dataField: 'Page', text: 'Page' }
];
var orderColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });


class PropertyReportDeedMainForm extends Component {
    constructor(...args) {
        super(...args);
    }
    componentDidMount() {

        CallAPI(
            {"OrderId":this.props.OrderId,"OrderProductId":this.props.OrderProductId},
            appConfig.apiGateway.PropertyReport,
            this.props,
            "GetDeeds",
            this.props.Error,
            this.props.Error,this.props.LoadAllDeeds)
            if (this.props.alldeeds && this.props.alldeeds.length > 0)
                this.props.SetDeed(this.props.alldeeds[0])
    }
    render() {
        return (
            <>
            <PropReportDeedGrid OrderColumns={orderColumns}/>
            <PropertyReportDeed OrderId={this.props.OrderId} />  
            <Button type="button" onClick={()=> {
                         this.props.ShowAddDeed()
                 }
                      }>Add Deed</Button>
            </>
        );
}
}
const validate = (formValues) => {
    const errors = {};
    return errors;
}
var propReportMain  = connect(state => ({ 
    session: state.session,
    alldeeds: state.loadDeed.alldeeds
   }),
{ LoadAllDeeds,SetDeed,ShowAddDeed})(PropertyReportDeedMainForm);
export default propReportMain;